import api from './Axios'; // Adjust this path to point to your configured Axios instance

export const expertBlogAPI = {
  // 🟢 1. Create a new blog post
  createPost: async (data: {
    title: string;
    content: string;
    expertCode: string;
    expertName: string;
    categoryId?: string | number | null; 
    subCategoryId?: string | number | null;
    blogStatus?: string;
    coverImage?: string;
  }) => {
    const response = await api.post('/api/expert-blogs', data);
    return response.data;
  },

  // 🟢 2. Fetch all blogs for an expert profile
  getBlogsByExpert: async (expertCode: string) => {
    const response = await api.get(`/api/expert-blogs/expert/${expertCode}`);
    return response.data;
  },

  // 🟢 3. Fetch ALL published blogs for the homepage
  getAllPublishedBlogs: async () => {
    const response = await api.get('/api/expert-blogs/public/published');
    return response.data;
  },

  // 🟢 4. Fetch a single blog post by its ID for the reading page
  getBlogById: async (blogId: string | number) => {
    const response = await api.get(`/api/expert-blogs/${blogId}`);
    return response.data;
  },

  // 🟢 5. Record a view (called automatically when a user opens the blog)
  recordView: async (blogId: number | string) => {
    const response = await api.patch(`/api/expert-blogs/${blogId}/view`);
    return response.data;
  },

  // 🟢 6. Record a like (called when a user clicks the thumbs up)
  recordLike: async (blogId: number | string) => {
    const response = await api.patch(`/api/expert-blogs/${blogId}/like`);
    return response.data;
  },

  // 🟢 7. Submit a text review/comment on a blog
  submitBlogReview: async (
    blogId: number | string, 
    data: { userId: string; userName: string; reviewText: string }
  ) => {
    const response = await api.post(`/api/expert-blogs/${blogId}/reviews`, data);
    return response.data;
  },

  // 🟢 8. Fetch all visible reviews for a specific blog
  getBlogReviews: async (blogId: number | string) => {
    const response = await api.get(`/api/expert-blogs/${blogId}/reviews`);
    return response.data;
  },

  // 🟢 9. Securely upload cover image to your NestJS backend
  uploadCoverImage: async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post('/api/expert-blogs/upload-cover', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data; // Expected to return { url: "https://cloudinary..." }
  },

  // 🟢 10. NEW: Edit/Update an existing blog post (Automatically sets status back to pending)
  updateBlog: async (
    blogId: string | number,
    data: {
      title?: string;
      content?: string;
      categoryId?: string | number | null; 
      subCategoryId?: string | number | null;
      coverImage?: string;
    }
  ) => {
    const response = await api.patch(`/api/expert-blogs/${blogId}/edit`, data);
    return response.data;
  },

  // 🟢 11. NEW: Delete a blog post
  deleteBlog: async (blogId: string | number) => {
    const response = await api.delete(`/api/expert-blogs/${blogId}`);
    return response.data;
  }
};